module.exports = __webpack_public_path__ + "img/4.3fdb55e0.jpg";